import {BindingOptions} from 'vuex-class/lib/bindings';

export class StoreNamespace {
  public static readonly AUTHENTICATION_MODULE: string = 'authentication';
  public static readonly AUTHORIZATION_MODULE: string = 'authorization';
  public static readonly LOBBY_MODULE: string = 'lobby';
  public static readonly FORM_MODULE: string = 'form';
  public static readonly DOCUMENT_MODULE: string = 'document';
  public static readonly MESSAGE_MODULE: string = 'message';
  public static readonly MANAGER_MODULE: string = 'manager';
  public static readonly CUSTOMER_MODULE: string = 'customer';
  public static readonly SYSTEM_MODULE: string = 'system';
  public static readonly MESSAGES_MODULE: string = 'messages';
  public static readonly APPLICATION_USER_MODULE: string = 'applicationUser';
  public static readonly INSURERS_REPORTS_MODULE: string = 'insurersReports';
  public static readonly ADP_FILE_CONTROL_MODULE: string = 'adpFiles';

  public static readonly AUTHENTICATION: BindingOptions = { namespace: StoreNamespace.AUTHENTICATION_MODULE };
  public static readonly AUTHORIZATION: BindingOptions = { namespace: StoreNamespace.AUTHORIZATION_MODULE };
  public static readonly LOBBY: BindingOptions = { namespace: StoreNamespace.LOBBY_MODULE };
  public static readonly FORM: BindingOptions = { namespace: StoreNamespace.FORM_MODULE };
  public static readonly DOCUMENT: BindingOptions = { namespace: StoreNamespace.DOCUMENT_MODULE };
  public static readonly MESSAGE: BindingOptions = { namespace: StoreNamespace.MESSAGE_MODULE };
  public static readonly MANAGER: BindingOptions = { namespace: StoreNamespace.MANAGER_MODULE };
  public static readonly CUSTOMER: BindingOptions = { namespace: StoreNamespace.CUSTOMER_MODULE };
  public static readonly MESSAGES: BindingOptions = { namespace: StoreNamespace.MESSAGES_MODULE };
  public static readonly SYSTEM: BindingOptions = { namespace: StoreNamespace.SYSTEM_MODULE };
  public static readonly APPLICATION_USER: BindingOptions = { namespace: StoreNamespace.APPLICATION_USER_MODULE };
  public static readonly INSURERS_REPORTS: BindingOptions = { namespace: StoreNamespace.INSURERS_REPORTS_MODULE };
  public static readonly ADP_FILE_CONTROL: BindingOptions = { namespace: StoreNamespace.ADP_FILE_CONTROL_MODULE };


  public static readonly ACCESS_TOKEN_GETTER: string = StoreNamespace.AUTHORIZATION_MODULE + '/accessToken';
  public static readonly USER_DETAILS_GETTER: string = StoreNamespace.AUTHENTICATION_MODULE + '/userDetails';
}
